<script setup lang="ts">
import { computed } from 'vue'
import { Dieline } from '@/Composables/useCustomSizeLayout'

const props = defineProps<{
    dieline: Dieline
    x: number
    y: number
    rotated?: boolean
}>()

const columnBoundaries = computed(() => {
    let offset = 0
    return props.dieline.columns.slice(0, -1).map((column) => (offset += column.size))
})

const rowBoundaries = computed(() => {
    let offset = 0
    return props.dieline.rows.slice(0, -1).map((row) => (offset += row.size))
})

const transform = computed(() => props.rotated
    ? `translate(${props.x + props.dieline.height} ${props.y}) rotate(90)`
    : `translate(${props.x} ${props.y})`
)
</script>

<template>
    <g :transform="transform">
        <rect :width="dieline.width" :height="dieline.height" fill="#00a14b" stroke="#14532d"
            vector-effect="non-scaling-stroke" stroke-width="1" />
        <line v-for="(boundary, index) in columnBoundaries" :key="`column-${index}`" :x1="boundary" :x2="boundary"
            y1="0" :y2="dieline.height" stroke="#111827" stroke-width="1" vector-effect="non-scaling-stroke" />
        <line v-for="(boundary, index) in rowBoundaries" :key="`row-${index}`" x1="0" :x2="dieline.width"
            :y1="boundary" :y2="boundary" stroke="#111827" stroke-width="1" vector-effect="non-scaling-stroke" />
    </g>
</template>
